(() => {
  const storageKey = 'punartha-colour-mode';
  const modes = ['dark', 'light'];
  const labels = {
    dark: 'Dark',
    light: 'Light',
  };
  const root = document.documentElement;

  const getPreference = () => {
    const current = root.dataset.themePreference;
    return modes.includes(current) ? current : 'dark';
  };

  const updateThemeColour = (resolvedMode) => {
    const meta = document.querySelector('meta[data-theme-color]');
    if (!meta) return;

    const styles = window.getComputedStyle(root);
    const colour = resolvedMode === 'dark'
      ? styles.getPropertyValue('--pta-loom-night').trim() || '#211E10'
      : styles.getPropertyValue('--cream-50').trim() || '#FAF6EE';

    meta.setAttribute('content', colour);
  };

  const updateControls = () => {
    const preference = getPreference();
    const nextMode = modes[(modes.indexOf(preference) + 1) % modes.length];

    document.querySelectorAll('[data-theme-toggle]').forEach((button) => {
      button.dataset.themeMode = preference;
      button.setAttribute(
        'aria-label',
        `Colour mode: ${labels[preference]}. Activate for ${labels[nextMode]}.`,
      );
      button.setAttribute('title', `Colour mode: ${labels[preference]}`);

      const label = button.querySelector('[data-theme-label]');
      if (label) label.textContent = labels[preference];
    });
  };

  const applyPreference = (preference, persist = false) => {
    const safePreference = modes.includes(preference) ? preference : 'dark';
    const resolvedMode = safePreference;

    root.dataset.themePreference = safePreference;
    root.dataset.theme = resolvedMode;
    root.style.colorScheme = resolvedMode;

    if (persist) {
      try {
        window.localStorage.setItem(storageKey, safePreference);
      } catch (error) {
        // Storage can be unavailable in strict privacy contexts. The mode still
        // applies for the current page and resets to the merchant default later.
      }
    }

    updateThemeColour(resolvedMode);
    updateControls();
    window.dispatchEvent(new CustomEvent('punartha:theme-change', {
      detail: { preference: safePreference, resolvedMode },
    }));
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-theme-toggle]');
    if (!button) return;

    const current = getPreference();
    const nextMode = modes[(modes.indexOf(current) + 1) % modes.length];
    applyPreference(nextMode, true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applyPreference(getPreference()), { once: true });
  } else {
    applyPreference(getPreference());
  }

  document.addEventListener('shopify:section:load', updateControls);

  window.PunarthaTheme = {
    getPreference,
    getResolvedMode: () => root.dataset.theme,
    setPreference: (preference) => applyPreference(preference, true),
  };
})();
